<template>
    <div class="container">
        <modal-x :show="showContacts" @onclose="showContacts=false" :contentStyle="{'max-width': '600px', height: '80%'}" :modal-style="{'margin-top':'50px'}">
            <paged-contact-core :userId="userId" v-if="showContacts" :apiClient="apiClient.contactsApiClient" :pickupEntry="true"></paged-contact-core>
        </modal-x>
        <div class="btn btn-default" style="margin:4px;float:left;"><router-link
                :to="{ path: 'shopInfo',query: { shopUserId: userId } }">Shops</router-link></div>
        <h1>Settings</h1>
        <div>
            <div>Shop Tags</div>
            <category :user-id="userId" :cat-node="catNodes['shopTag'].node" :show-create-node="catNodes['shopTag'].showCreateNode" cat-type="shopTag" :expandAll="true" :view-mode="{}"></category>
            <div>Shop Industries</div>
            <category :user-id="userId" :cat-node="catNodes['industry'].node" :show-create-node="catNodes['shopTag'].showCreateNode" cat-type="industry" :expandAll="true" :view-mode="{}"></category>
            
            <div>Countrty Cities</div>
            <category :user-id="userId" :cat-node="catNodes['countryCity'].node" :show-create-node="catNodes['shopTag'].showCreateNode" cat-type="countryCity" :expandAll="true" :view-mode="{}"></category>
            <div>Phone Districts</div>
            <category :user-id="userId" :cat-node="catNodes['phoneDistrict'].node" :show-create-node="catNodes['shopTag'].showCreateNode" cat-type="phoneDistrict" :expandAll="true" :view-mode="{}"></category>
            <div>Order Extras</div>
            <category :user-id="userId" :cat-node="catNodes['orderExtra'].node" :show-create-node="catNodes['shopTag'].showCreateNode" cat-type="orderExtra" :expandAll="true" :view-mode="{}"></category>
            <div>Pickup Locations</div>
            <category :user-id="userId" :cat-node="catNodes['pickupLocation'].node" :show-create-node="catNodes['shopTag'].showCreateNode" cat-type="pickupLocation" :expandAll="true" :view-mode="{}"></category>
        </div>
        <div>
            <span class="btn btn-default" @click="showContacts=true">Pickup location</span>
        </div>
    </div>
</template>
<script>
import apis from '../api/extApi.js';
import category from './category.vue';
import modalX from '../components/base/ModalX1.vue';
import PagedContactCore from '../components/PagedContactCore.vue';

export default {
    components: {
        PagedContactCore:PagedContactCore,
        category: category,
        modalX: modalX
    },
    props: {
        "userId": String,
    },
    data: function () {
        return {
            apiClient: apis.api,
            catCodes: apis.api.settings.catCodes,
            catNodes:{
                countryCity:{node:null,showCreateNode:false},
                phoneDistrict:{node:null,showCreateNode:false},
                orderExtra:{node:null,showCreateNode:false},
                pickupLocation:{node:null,showCreateNode:false},
                shopTag:{node:null,showCreateNode:false},
                industry:{node:null,showCreateNode:false}
            },
            showContacts:false
        }
    },
    methods: {
        getCategoryNode(catType) {
            this.apiClient.getCategoryNodePrms(this.catCodes[catType], this.shopUserId).done((ret) => {
                this.catNodes[catType].node = ret;
                this.catNodes[catType].showCreateNode = ret === null;
            });
        }
    },
    created: function () {
        var catTypes = ["countryCity","phoneDistrict","orderExtra","pickupLocation","shopTag","industry"];
        catTypes.forEach(t => {
            this.getCategoryNode(t);
        });
    },
    mounted:function(){

    }
}
</script>